import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer2_en',
  templateUrl: './footer2_en.component.html',
  styleUrls: ['./footer2_en.component.css']
})
export class Footer2_enComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
